import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { APIRequest } from '../../common/Common';
import { getAlertMessageFunction, handleRejected } from '../../common/Util';

const initialState = {
  isLogin: false,
  status: 'guest',

  resultCode: -1,

  htmAlias: null,
  certifyDate: '',
};

//로그인
export const getLoginCheck = createAsyncThunk('loginSlice/getLoginCheck', async data => {
  const response = await APIRequest('/getLoginCheck', {
    ...data,
    htmFlag: 'M',
  });
  console.log('response 11111>>', response);
  return response;
});

//문자인증성공여부
export const getSmsLoginCheck = createAsyncThunk('loginSlice/smsLoginCheck', async data => {
  const response = await APIRequest('/YA/smsLoginCheck', data);
  return response;
});

//문자보내기
export const getSMSAuthNumber = createAsyncThunk('loginSlice/getSMSAuthNumber', async data => {
  const response = await APIRequest('/YA/getSMSAuthNumber', data);
  return response;
});

//문자인증 로그인
export const smsLoginSession = createAsyncThunk('loginSlice/smsLoginSession', async data => {
  const response = await APIRequest('/YA/smsLoginSession', data);
  return response;
});

//생년월일 로그인
export const getBirthLoginCheck = createAsyncThunk('loginSlice/getBirthLoginCheck', async data => {
  const response = await APIRequest('/getBirthLoginCheck', data);
  return response;
});

// 문자(LMS) 인증 - 생년월일 로그인
export const getSmsBirthLoginCheck = createAsyncThunk(
  'loginSlice/getSmsBirthLoginCheck',
  async data => {
    const { alias, ...params } = data;
    const response = await APIRequest('/NoPaperCertifyCheck_login', params, alias);
    return response;
  },
);

//서버구분 - SSO 로그인
export const getComAlias = createAsyncThunk('loginSlice/getComAlias', async data => {
  const response = await APIRequest('/YA/getComAlias', data);
  return response;
});

export const logout = createAsyncThunk('loginSlice/logout', async () => {
  const response = await APIRequest('/logout');
  return response;
});

const loginSlice = createSlice({
  name: 'loginSlice',
  initialState,
  reducers: {
    tempLogin: state => {
      state.isLogin = true;
      state.status = 'success';
      state.msg = 'temp login';
      state.resultCode = 200;
    },
    clearLogin: state => {
      state.isLogin = false;
      state.status = 'guest';
      state.msg = '';
      state.resultCode = -1;
      state.info = null;
      sStorage.clear();
    },
    setLogin: (state, action) => {
      state.isLogin = action.payload;
    },
    // logout: state => {
    //   console.log('logout');
    //   window.sessionStorage.clear();
    //   // redux 상태는 rootReducer에서 처리하므로 여기서는 상태를 변경하지 않음
    //   sStorage.clear();
    //   state.status = 'guest';
    //   state.msg = '';
    //   state.resultCode = -1;
    //   (state.info = null), (state.isLogin = false);
    // },
    setType: state => {
      state.type = '';
    },
  },
  extraReducers: builder => {
    builder.addCase(getLoginCheck.fulfilled, (state, action) => {
      console.log('getLoginCheck.fulfilled 실행됨!!!!:', action);
      const alertMessage = getAlertMessageFunction();
      const { setLogin, msg } = action?.payload;

      if (setLogin == 'true') {
        const { htmsession, htmalias, htmpersabun } = action.payload;
        state.status = 'success';
        state.isLogin = true;
        sStorage.setItem('sessionId', htmsession);
        sStorage.setItem('htmpersabun', htmpersabun);
        sStorage.setItem('htmAlias', htmalias || 'jan');
      } else {
        handleRejected(state, action, ['isLogin', 'status']);
        if (msg) alertMessage(msg, 'error');
        else alertMessage('등록된 정보가 없습니다.', 'error');
      }
    });

    builder.addCase(smsLoginSession.fulfilled, (state, action) => {
      console.log('smsLoginSession.fulfilled 실행됨!!!!:', action);
      const alertMessage = getAlertMessageFunction();
      const { htmSession, htmAlias } = action?.payload;

      if (htmSession) {
        state.status = 'success';
        state.isLogin = true;
        sStorage.setItem('sessionId', htmSession);
        sStorage.setItem('htmAlias', htmAlias || 'jan');
      } else {
        handleRejected(state, action, ['isLogin', 'status']);
        alertMessage('등록된 정보가 없습니다.', 'error');
      }
    });

    builder.addCase(getBirthLoginCheck.fulfilled, (state, action) => {
      console.log('getBirthLoginCheck.fulfilled 실행됨!!!!:', action);
      const alertMessage = getAlertMessageFunction();
      const { setLogin, msg } = action?.payload;

      if (setLogin == 'true') {
        const { htmsession, htmalias, htmpersabun } = action.payload;
        state.status = 'success';
        state.isLogin = true;
        sStorage.setItem('sessionId', htmsession);
        sStorage.setItem('htmpersabun', htmpersabun);
        sStorage.setItem('htmAlias', htmalias || 'jan');
      } else {
        handleRejected(state, action, ['isLogin', 'status']);
        if (msg) alertMessage(msg, 'error');
        else alertMessage('등록된 정보가 없습니다.', 'error');
      }
    });

    builder.addCase(getSmsBirthLoginCheck.fulfilled, (state, action) => {
      console.log('getSmsBirthLoginCheck.fulfilled 실행됨!!!!:', action); // 인증 로그인 !!!!!
      const alertMessage = getAlertMessageFunction();
      const { htmsession } = action?.payload;

      if (htmsession) {
        const { htmsession, htmalias, htmpersabun, certifyDate, htmKey } = action.payload;
        state.status = 'success';
        state.isLogin = true;
        state.certifyDate = certifyDate;
        sStorage.setItem('sessionId', htmsession);
        sStorage.setItem('htmpersabun', htmpersabun);
        sStorage.setItem('htmAlias', htmalias || 'jan');
        sStorage.setItem('htmKey', htmKey || ''); // 웹일 때 yearend-web 에 던지는 키
      } else {
        handleRejected(state, action, ['isLogin', 'status']);
        // alertMessage(action.payload?.resultMsg || '등록된 정보가 없습니다.', 'error');
      }
    });

    builder.addCase(getComAlias.fulfilled, (state, action) => {
      console.log('getComAlias.fulfilled 실행됨!!!!:', action);
      const alertMessage = getAlertMessageFunction();
      const { htmalias, htmcomcd } = action?.payload;
      if (htmalias) {
        window.location.href = `https://${htmalias}.himgt.net/servlets/saml?cmd=signin&comcd=${htmcomcd}&mobile=Y&service=yearend`;
      } else {
        alertMessage('일치하는 데이터가 없습니다.', 'error');
      }
    });

    builder.addCase(logout.fulfilled, (state, action) => {
      const alertMessage = getAlertMessageFunction();
      state.status = 'guest';
      state.isLogin = false;
      state.htmAlias = null;
      sStorage.clear();
      alertMessage('로그아웃 되었습니다.');
    });

    // rejected
    builder.addCase(getLoginCheck.rejected, (state, action) => {
      sStorage.clear();
      state.status = 'guest';
      state.isLogin = false;
      state.htmAlias = null;
    });
  },
});
export default loginSlice.reducer;
export const { tempLogin, setType, clearLogin, setLogin } = loginSlice.actions;
